import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const LPHeader = ({ onOpenModal }) => {
  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-2">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0">
            <img 
              src="/logo.png" 
              alt="Crystal Trademark" 
              className="h-10 sm:h-12 w-auto"
            />
          </div>

          {/* Phone and Buttons */}
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Phone Number - Hidden on mobile */}
            <a 
              href="tel:+18882032966" 
              className="hidden lg:flex items-center gap-2 text-[#012169] hover:text-[#F97316] transition-colors font-semibold"
            >
              <Phone className="h-4 w-4" />
              <span className="text-sm">+1 (888) 203-2966</span>
            </a>
            
            <button
              onClick={() => onOpenModal && onOpenModal('Register My Trademark - Header')}
              className="bg-[#F97316] hover:bg-[#EA580C] text-white font-semibold px-3 sm:px-6 py-2 text-xs sm:text-base rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <span className="hidden sm:block">Register My Trademark</span>
              <span className="block sm:hidden">Register</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LPHeader;
